export class AuditoriaConferenciaCaixaGeral {
    id: number;
    valor: number;
    funcionarioId: number;
    caixaId: number;
    postoId: number;
    data: Date;
}